import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-generic-table-body-renderer',
  templateUrl: './generic-table-body-renderer.component.html',
  styleUrls: ['./generic-table-body-renderer.component.less'],
})
export class GenericTableBodyRendererComponent implements OnInit {
  @Input() data: any;

  constructor() {}

  ngOnInit(): void {}
}
